import React from "react";
// UI Framework
import DeleteIcon from "@mui/icons-material/Delete";
import { Edit } from "@mui/icons-material";
import { TableCell } from "@mui/material";
import { toast } from "react-toastify";
// Common Components
import { Loading } from "src/Components";
// Hooks
import { useAppDispatch } from "src/App/hooks";
// Utilities
import { deleteRiskProfile, getRiskProfileDropDown } from "src/Requests/coveredCall";
import { packetErrorHandler } from "src/Utils/requestUtils";
import { setRiskProfile, setRiskProfiles } from "src/Features/CoveredCall/CoveredCallSlice";
// Types
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { ProfileRiskReport } from "src/Interfaces/coveredCall";

const AdditionalHeader: React.FC = () => {
  return (
    <>
      <TableCell />
    </>
  );
};

const AdditionalCol: React.FC<{
  row: ProfileRiskReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  // hooks
  const dispatch = useAppDispatch();
  // states
  const [loading, setLoading] = React.useState(false);

  const cancelHandler = () => {
    setLoading(true);
    deleteRiskProfile(row.id)
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);
          onAction();
          getRiskProfileDropDown()
            .then((profiles) => dispatch(setRiskProfiles([{ id: "0", name: "تجمیعی" }, ...profiles])))
            .catch(packetErrorHandler);
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  const editHandler = () => {
    dispatch(setRiskProfile({ profileName: row.profileName, id: row.id }));
  };

  return (
    <>
      <TableCell>
        <div onClick={editHandler}>
          <Edit className="!text-sky-700" />
        </div>
      </TableCell>
      <TableCell>
        <div onClick={cancelHandler}>
          {loading ? (
            <Loading size={16} className="!text-slate-700" />
          ) : (
            <DeleteIcon className="!text-red-700" />
          )}
        </div>
      </TableCell>
    </>
  );
};

export const Additional: IAdditional<ProfileRiskReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
